// extracted by mini-css-extract-plugin
export default {"root":"IconSupercap_root__oNOjm","filled":"IconSupercap_filled__X32dx"};